// extracted by mini-css-extract-plugin
module.exports = {"title":"_3ino7giP-i2MH9LJ3anymV","link":"_2hp8FsONTAU9Jx8HWet7Xe"};